import { render, staticRenderFns } from "./waters.vue?vue&type=template&id=1bd3d5d3&scoped=true"
import script from "./waters.vue?vue&type=script&lang=js"
export * from "./waters.vue?vue&type=script&lang=js"
import style0 from "./waters.vue?vue&type=style&index=0&id=1bd3d5d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3d5d3",
  null
  
)

export default component.exports